var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"scrollspy",rawName:"v-scrollspy",value:({targets: _vm.targets, direction: _vm.direction}),expression:"{targets, direction}"}],staticClass:"scroll-spy",style:(_vm.styles)},[_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b92daf14","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/scroll-spy/scroll-spy.vue
// module id = 542
// module chunks = 0 1 4 50